import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { useT } from "@/lib/i18n";
import { api, errMsg, fmtTime, fmtDate } from "@/lib/api";
import { TimeInput } from "@/components/kv";

export const CorrectionDialog = ({ rec, name, onClose, onSaved }) => {
  const { t, lang } = useT();
  const [cin, setCin] = useState(fmtTime(rec.clock_in));
  const [cout, setCout] = useState(rec.clock_out ? fmtTime(rec.clock_out) : "");
  const [note, setNote] = useState("");

  const save = async () => {
    try {
      await api.put(`/admin/attendance/${rec.id}`, { clock_in: cin || null, clock_out: cout || null, admin_note: note });
      toast.success(t("req.saved"));
      onSaved();
      onClose();
    } catch (e) {
      toast.error(errMsg(e, t));
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#FFFCF7]" data-testid="correction-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{t("req.edit_title")}</DialogTitle>
          <DialogDescription>{name} · <span className="capitalize">{fmtDate(rec.date, lang)}</span></DialogDescription>
        </DialogHeader>
        <p className="text-sm text-stone-500">{t("req.edit_hint")}</p>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1"><Label>{t("dash.col_in")}</Label><TimeInput value={cin} onChange={setCin} className="bg-white font-mono-kv w-full" data-testid="correction-in-input" /></div>
          <div className="space-y-1"><Label>{t("dash.col_out")}</Label><TimeInput value={cout} onChange={setCout} className="bg-white font-mono-kv w-full" data-testid="correction-out-input" /></div>
        </div>
        <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder={t("req.note_ph")} maxLength={300} className="bg-white" data-testid="correction-note-input" />
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>{t("common.cancel")}</Button>
          <Button className="rounded-full" onClick={save} disabled={!cin} data-testid="correction-save-button">{t("common.save")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
